import { ValidationError } from 'class-validator';

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
  errorMessages: string[];
}

export function formatValidationErrors(errors: ValidationError[], parentPath = ''): string[] {
  const messages: string[] = [];

  for (const error of errors) {
    const propertyPath = parentPath ? `${parentPath}.${error.property}` : error.property;

    // Add constraint messages if present
    if (error.constraints) {
      Object.values(error.constraints).forEach((message) => {
        messages.push(`${propertyPath}: ${message}`);
      });
    }

    // Recursively handle nested errors
    if (error.children && error.children.length > 0) {
      messages.push(...formatValidationErrors(error.children, propertyPath));
    }
  }

  return messages;
}
